import { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { Table, Form, Button } from "react-bootstrap";
import CustomPagination from "../../../components/CustomPagination";

const ExamTable = ({ data }) => {
  const today = new Date();

  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const formatDate = (obj) => {
    if (!obj?.$date) return "-";
    return new Date(obj.$date).toLocaleDateString();
  };

  const checkIsActive = (start, end) => {
    if (!start?.$date || !end?.$date) return false;
    const s = new Date(start.$date);
    const e = new Date(end.$date);
    return today >= s && today <= e;
  };

  const completedTests = (userTests) =>
    userTests?.filter((u) => u.test_completed === 1).length || 0;

  // PAGINATION LOGIC
  const totalRows = data.length;
  const totalPages = Math.ceil(totalRows / rowsPerPage);
  const start = totalRows === 0 ? 0 : (currentPage - 1) * rowsPerPage + 1;
  const end = Math.min(currentPage * rowsPerPage, totalRows);
  const paginated = data.slice(start - 1, end);

  const handleEdit = (exam) => {
    navigate(`/home/exam-edit/${exam.id}`, { state: { exam } });
  };

  return (
    <>
      {/* TABLE */}
      <Table striped bordered hover responsive className="bg-white">
        <thead className="bg-light">
          <tr>
            <th>Name</th>
            <th>Classes Enabled</th>
            <th>Registration Start</th>
            <th>Start Date</th>
            <th>Is Active</th>
            <th>Attempting</th>
            <th>Completed</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {paginated.length > 0 ? (
            paginated.map((exam, index) => (
              <tr key={index}>
                <td>{exam.name}</td>

                <td>{exam.classes_enabled?.join(", ")}</td>

                <td>{formatDate(exam.registration_start_date)}</td>

                <td>{formatDate(exam.start_time)}</td>

                <td>
                  {checkIsActive(exam.start_time, exam.end_time) ? (
                    <span className="badge bg-success">Active</span>
                  ) : (
                    <span className="badge bg-secondary">Inactive</span>
                  )}
                </td>

                <td>{exam.attempting}</td>

                <td>{completedTests(exam.user_tests)}</td>
                <td>
                  <Button
                    variant="link"
                    size="sm"
                    onClick={() => {handleEdit(exam)}}
                  >
                    Edit
                  </Button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="7" className="text-center text-muted">
                No exam data available
              </td>
            </tr>
          )}
        </tbody>
      </Table>

      {/* PAGINATION SECTION */}
      <div className="d-flex justify-content-between align-items-center flex-wrap my-3">
        <div className="text-muted">
          Showing {start}–{end} of {totalRows} exams
        </div>

        <div className="d-flex align-items-center">
          <span className="me-2">Rows per page:</span>
          <Form.Select
            value={rowsPerPage}
            onChange={(e) => {
              setRowsPerPage(Number(e.target.value));
              setCurrentPage(1);
            }}
            style={{ width: "80px" }}
          >
            {[10, 20, 30, 40, 50].map((v) => (
              <option key={v} value={v}>
                {v}
              </option>
            ))}
          </Form.Select>
        </div>

        <CustomPagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={(p) => setCurrentPage(p)}
        />
      </div>
    </>
  );
};

export default ExamTable;
